export enum NotificationTypes {
  GameInstanceWinnerNotifications = 1,
  EscalatedSupportRequestsNotifications = 3,
  CharityNameChangeNotifications = 4,
  LotteryLicenseExpirationNotification = 5,
  InvalidGameSettingsNotification = 6,
  RefundErrorNotification = 7,
  MassRefundErrorNotification = 8
}
